import _ from 'lodash'
import axios from "../axios";
import {
    ISysConfigGetDeepSeekSettingData,
    ISysConfigGetPlatformScreenSettingData,
    ISysConfigGetSysDictData,
    ISysConfigGetSysDictParams,
    ISysConfigPlatformScreenSettingParams,
    ISysConfigSetDeepSeekSettingParams
} from './sysConfig.types';

/**
 *  获取深度搜索配置
 */
export function sysConfigGetDeepSeekSetting() {
    return axios<ISysConfigGetDeepSeekSettingData>({
        method: 'get',
        url: '/sysConfig/getDeepSeekSetting',
    })
}

/**
 *  设置深度搜索配置
 */
export function sysConfigSetDeepSeekSetting(params: ISysConfigSetDeepSeekSettingParams) {
    return axios({
        method: 'put',
        url: '/sysConfig/deepSeekSetting',
        data: params
    })
}

/**
 * 获取平台大屏价值指标配置
 */
export function sysConfigGetPlatformScreenSetting() {
    return axios<ISysConfigGetPlatformScreenSettingData>({
        method: 'get',
        url: '/sysConfig/getPlatformScreenSetting',
    })
}

/**
 * 保存平台大屏价值指标配置
 */
export function sysConfigPlatformScreenSetting(params: ISysConfigPlatformScreenSettingParams) {
    return axios({
        method: 'put',
        url: '/sysConfig/platformScreenSetting',
        data: params
    })
}

/**
 * 获取字典类型
 */
export function sysConfigGetSysDict(params: ISysConfigGetSysDictParams) {
    return axios<ISysConfigGetSysDictData>({
        method: 'get',
        url: '/sysConfig/getSysDict',
        params
    })
}
